import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  useDispatch, connect
} from "react-redux";
import {
  Modal, Button,
  ModalHeader,
  ModalBody,
  UncontrolledAlert,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { addIpBlock } from "store/ipAccessControl/actions";
import Loader from "components/Common/Loader";

function IpAccessControlAdd(props) {
  const [addModal, setAddModal] = useState(false);
  const dispatch = useDispatch();
  const { create } = props.ipAccessControlPermissions;
  const toggleAddModal = () => {
    setAddModal(!addModal);
  };
  const handleAddBlock = (e, values) => {
    dispatch(addIpBlock({
      ip: values.ip,
      note: values.note,
      durationMs: values.durationMs ? Number(values.durationMs) : null,
    }));
  };
  useEffect(() => {
    if (props.clearingCounter > 0 && addModal) {
      setAddModal(false);
    }
  }, [props.clearingCounter]);

  return (
    <React.Fragment >
      <Link to="#" className={`btn btn-primary ${!create ? "d-none" : ""}`} onClick={toggleAddModal}><i className="bx bx-plus me-1"></i> {props.t("Block IP")}</Link>
      <Modal isOpen={addModal} toggle={toggleAddModal} centered={true}>
        <ModalHeader toggle={toggleAddModal} tag="h4">
          {props.t("Block IP")}
        </ModalHeader>
        <ModalBody >
          <AvForm
            className='p-4'
            onValidSubmit={(e, v) => {
              handleAddBlock(e, v);
            }}
          >
            <div className="mb-3">
              <AvField
                name="ip"
                label={props.t("IP Address")}
                placeholder={props.t("Enter IP Address")}
                type="text"
                errorMessage={props.t("Enter a valid IP Address")}
                validate={
                  {
                    required: { value: true },
                    pattern: { value: "^[0-9a-fA-F.:]+$" },
                  }
                }
              />
            </div>
            <div className="mb-3">
              <AvField
                name="note"
                label={props.t("Note")}
                placeholder={props.t("Reason for blocking (optional)")}
                type="text"
              />
            </div>
            <div className="mb-3">
              <AvField
                name="durationMs"
                label={props.t("Duration")}
                type="select"
              >
                <option value="">{props.t("Permanent")}</option>
                <option value={1800000}>{props.t("30 minutes")}</option>
                <option value={3600000}>{props.t("1 hour")}</option>
                <option value={86400000}>{props.t("24 hours")}</option>
                <option value={604800000}>{props.t("7 days")}</option>
              </AvField>
            </div>
            <div className='text-center pt-3 p-2'>
              {
                props.addLoading
                  ?
                  <Loader />
                  :
                  <Button disabled={props.addLoading} type="submit" color="primary" className="">
                    {props.t("Block")}
                  </Button>
              }
            </div>
          </AvForm>
          {props.addError && <UncontrolledAlert color="danger">
            <i className="mdi mdi-block-helper me-2"></i>
            {props.addErrorDetails}
          </UncontrolledAlert>}
          {props.addSuccess && <UncontrolledAlert color="success">
            <i className="mdi mdi-check-all me-2"></i>
            {props.t("IP Blocked successfully")} !!!
          </UncontrolledAlert>}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


const mapStateToProps = (state) => ({
  addLoading: state.ipAccessControlReducer.addLoading,
  addErrorDetails: state.ipAccessControlReducer.addErrorDetails,
  addSuccess: state.ipAccessControlReducer.addSuccess,
  addError: state.ipAccessControlReducer.addError,
  clearingCounter: state.ipAccessControlReducer.clearingCounter,
  ipAccessControlPermissions: state.Profile.permissions?.ipAccessControl || {},
});
export default connect(mapStateToProps, null)(IpAccessControlAdd);
